import React, {PropTypes} from 'react';
import styles from '../SearchResults.scss';
import FilterBar from './FilterBar';
import Results from './Results';
import Analogs from './Analogs';
import {Button, ButtonGroup} from 'src/components/Common/reactstrap/lib';

export default class SearchInfo extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      type: 'results'
    };
  }
  setType = (type) =>
    this.setState({
      type
    });

  render() {
    let props = this.props;
    return (
      <div className={styles.left_col}>
        <ButtonGroup className="hidden-sm-up btn-center">
          <Button color={(this.state.type == 'results') ? 'secondary' : 'info'}
                  onClick={() => this.setType('results')}> Искомый артикул</Button>{' '}
          <Button color={(this.state.type == 'analogs') ? 'secondary' : 'info' }
                  onClick={() => this.setType('analogs')}>Аналоги</Button>
        </ButtonGroup>
        <FilterBar
          inStock={props.inStock}
          filterInStock={props.filterInStock}
          filterPriceMinValue={props.filterPriceMinValue}
          filterPriceMaxValue={props.filterPriceMaxValue}
          isAskSupplier={props.isAskSupplier}
          supplierFilterValues={props.supplierFilterValues}
          filterSupplier={props.filterSupplier}
          bestOfferValue={props.bestOfferValue}
          filterBestOffers={props.filterBestOffers}
          foundDetailOffers={props.foundDetailOffers}
        />
        <Results
          className={this.state.type != 'results' && 'hidden-sm-down' }
          inStock={props.inStock}
          openToCartPopup={props.openToCartPopup}
          foundDetail={props.foundDetail}
          foundDetailOffers={props.foundDetailOffers}
          priceMinValue={props.priceMinValue}
          priceMaxValue={props.priceMaxValue}
          isAskSupplier={props.isAskSupplier}
          supplierFilterValues={props.supplierFilterValues}
          bestOfferValue={props.bestOfferValue}
        />
        <Analogs
          className={this.state.type == 'results' && 'hidden-sm-down' }
          inStock={props.inStock}
          openToCartPopup={props.openToCartPopup}
          foundDetail={props.foundDetail}
          foundDetailOffers={props.foundDetailOffers}
          priceMinValue={props.priceMinValue}
          priceMaxValue={props.priceMaxValue}
          isAskSupplier={props.isAskSupplier}
          supplierFilterValues={props.supplierFilterValues}
          bestOfferValue={props.bestOfferValue}
        />
      </div>
    );
  }
}

SearchInfo.propTypes = {
  openToCartPopup: PropTypes.func,
  foundDetail: PropTypes.object,
  foundDetailOffers: PropTypes.array,
  inStock: PropTypes.bool,
  filterInStock: PropTypes.func,
  filterPriceMinValue: PropTypes.func,
  filterPriceMaxValue: PropTypes.func,
  filterSupplier: PropTypes.func,
};



/** WEBPACK FOOTER **
 ** ./src/components/SearchResults/elements/SearchInfo.jsx
 **/